import { ValueFormatterParams } from 'ag-grid-community';

export function agGridCurrencyFormatter(
  params: ValueFormatterParams<string | number | undefined | null>
): string {
  const numericValue = Number(params.value);
  if (!isNaN(numericValue)) {
    return currencyFormatter(numericValue);
  }
  return '';
}

export function currencyFormatter(value: number): string {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return currencyFormatter.format(value);
}
